export const REPLAY_TIME_OPTIONS_SECONDS = [
  60 * 5, // 5 minutes
  60 * 10, // 10 minutes
  60 * 15, // 15 minutes
  60 * 30, // 30 minutes
  60 * 60, // 1 hour
  60 * 60 * 2, // 2 hours
  60 * 60 * 3, // 3 hours
  60 * 60 * 6, // 6 hours
];
